import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const INITIAL_TEMPLATES = [
  { id: 1, title: 'Interview Invitation', subject: 'Interview Invitation - RM Ghana', body: 'Dear {name}, we are pleased to invite you for an interview for the {role} position...', category: 'Scheduling' },
  { id: 2, title: 'Job Offer Draft', subject: 'Job Offer: {role} at RM Ghana', body: 'Congratulations {name}! We are excited to offer you the position...', category: 'Offers' },
];

const MESSAGES = [
  { id: 1, candidate: 'Yaw Mensah', subject: 'Interview Confirmation', status: 'Delivered', date: 'Oct 26, 2023 09:15 AM', type: 'Email' },
  { id: 2, candidate: 'Ama Serwaa', subject: 'Assignment Details', status: 'Opened', date: 'Oct 25, 2023 02:30 PM', type: 'Email' },
];

const CandidateCommunication = () => {
  const [activeTab, setActiveTab] = useState('compose');
  const [isSending, setIsSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [templates, setTemplates] = useState(INITIAL_TEMPLATES);
  const [editingTemplate, setEditingTemplate] = useState(null);
  
  const [composeData, setComposeData] = useState({
    to: '',
    subject: '',
    template: '',
    message: ''
  });

  const handleSend = (e) => {
    e.preventDefault();
    setIsSending(true);
    setTimeout(() => {
      setIsSending(false);
      setSendSuccess(true);
      setComposeData({ to: '', subject: '', template: '', message: '' });
      setTimeout(() => setSendSuccess(false), 3000);
    }, 1500);
  };

  const applyTemplate = (template) => {
    setComposeData({
      ...composeData,
      subject: template.subject,
      message: template.body,
      template: template.title
    });
  };

  const handleSaveTemplate = (e) => {
    e.preventDefault();
    if (editingTemplate.id) {
      setTemplates(templates.map(t => t.id === editingTemplate.id ? editingTemplate : t));
    } else {
      setTemplates([...templates, { ...editingTemplate, id: Date.now(), category: 'Custom' }]);
    }
    setEditingTemplate(null);
  };

  return (
    <div className="space-y-6 max-w-6xl mx-auto pb-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <div>
          <h1 className="text-[22px] font-bold text-gray-800">Candidate Communication</h1>
          <p className="text-gray-500 text-[13px] mt-1">Engage with talent and manage messaging history.</p>
        </div>
        <div className="flex bg-white p-1.5 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.04)] font-bold text-[11px] uppercase tracking-wider overflow-x-auto w-full md:w-auto border border-gray-50">
          <button onClick={() => setActiveTab('history')} className={`px-5 py-2.5 rounded-lg transition-all whitespace-nowrap ${activeTab === 'history' ? 'bg-[#21438B] text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>History</button>
          <button onClick={() => setActiveTab('compose')} className={`px-5 py-2.5 rounded-lg transition-all whitespace-nowrap ${activeTab === 'compose' ? 'bg-[#21438B] text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>Compose</button>
          <button onClick={() => setActiveTab('templates')} className={`px-5 py-2.5 rounded-lg transition-all whitespace-nowrap ${activeTab === 'templates' ? 'bg-[#21438B] text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>Templates</button>
        </div>
      </div>

      {activeTab === 'history' && (
        <div className="bg-white rounded-xl overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-50 text-gray-400 font-bold uppercase text-[10px] tracking-widest border-b border-gray-100">
                <tr>
                  <th className="px-6 py-4">CANDIDATE</th>
                  <th className="px-6 py-4">SUBJECT / MESSAGE</th>
                  <th className="px-6 py-4">CHANNEL</th>
                  <th className="px-6 py-4">STATUS</th>
                  <th className="px-6 py-4">DATE</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {MESSAGES.map((msg) => (
                  <tr key={msg.id} className="hover:bg-gray-50/50 transition-colors">
                    <td className="px-6 py-4 font-bold text-gray-800">{msg.candidate}</td>
                    <td className="px-6 py-4 text-gray-600 font-medium">{msg.subject}</td>
                    <td className="px-6 py-4">
                      <span className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-blue-50 text-[#21438B] text-[10px] font-bold uppercase tracking-wider w-fit">
                        <SafeIcon name="Mail" size={12} /> {msg.type}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${msg.status === 'Opened' ? 'bg-green-50 text-green-600' : 'bg-blue-50 text-[#21438B]'}`}>
                        {msg.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-400 font-medium">{msg.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'compose' && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8">
            <form onSubmit={handleSend} className="bg-white p-8 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-50/50 space-y-6">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-bold text-[#21438B]">New Message</h3>
                {sendSuccess && <span className="flex items-center gap-2 text-green-600 font-bold text-sm animate-bounce"><SafeIcon name="CheckCircle" size={16} /> Message Sent!</span>}
              </div>
              
              <div className="space-y-5">
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Recipient Name</label>
                  <input 
                    type="text" 
                    required 
                    value={composeData.to} 
                    onChange={(e) => setComposeData({...composeData, to: e.target.value})} 
                    placeholder="e.g. Yaw Mensah" 
                    className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all placeholder:text-gray-300 text-sm" 
                  />
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Subject Line</label>
                  <input 
                    type="text" 
                    required 
                    value={composeData.subject} 
                    onChange={(e) => setComposeData({...composeData, subject: e.target.value})} 
                    placeholder="Enter email subject" 
                    className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all placeholder:text-gray-300 text-sm" 
                  />
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Message Body</label>
                  <textarea 
                    rows={10} 
                    required 
                    value={composeData.message} 
                    onChange={(e) => setComposeData({...composeData, message: e.target.value})} 
                    placeholder="Type your message here..." 
                    className="w-full px-4 py-3 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all placeholder:text-gray-300 text-sm resize-none" 
                  />
                  <p className="text-[10px] text-gray-400 italic mt-2">Formatting tip: Use {"{name}"} for personalization.</p>
                </div>
              </div>

              <div className="pt-2">
                <button 
                  type="submit" 
                  disabled={isSending} 
                  className="bg-[#21438B] hover:bg-[#1a3670] text-white px-6 py-3 rounded-md font-bold flex items-center gap-2 disabled:opacity-50 text-[11px] uppercase tracking-wider transition-colors"
                >
                  <SafeIcon name={isSending ? "Loader" : "Send"} size={14} className={isSending ? "animate-spin" : "mr-1"} />
                  {isSending ? "SENDING..." : "SEND MESSAGE"}
                </button>
              </div>
            </form>
          </div>

          <div className="lg:col-span-4">
            <div className="bg-white p-6 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-50/50 h-full">
              <h4 className="font-bold flex items-center gap-2 uppercase tracking-widest text-[11px] text-[#21438B] mb-6">
                <SafeIcon name="FileText" size={14} /> 
                ONE-CLICK TEMPLATES
              </h4>
              <div className="space-y-4">
                {templates.map((temp) => (
                  <button 
                    key={temp.id} 
                    onClick={() => applyTemplate(temp)} 
                    className="w-full text-left p-4 rounded-lg bg-white border border-gray-100 hover:border-[#21438B] transition-all group" 
                  >
                    <span className="text-[13px] font-bold text-gray-800 block mb-1">{temp.title}</span>
                    <p className="text-[11px] text-gray-400 truncate">{temp.subject}</p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'templates' && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4 space-y-4">
            <div className="bg-white rounded-xl overflow-hidden shadow-sm">
              <div className="p-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
                <span className="font-bold text-xs uppercase tracking-widest text-gray-600">Saved Templates</span>
                <button 
                  onClick={() => setEditingTemplate({ title: '', subject: '', body: '' })}
                  className="p-1.5 text-white bg-[#21438B] rounded hover:bg-[#1a3670] transition-colors"
                >
                  <SafeIcon name="Plus" size={16} />
                </button>
              </div>
              <div className="divide-y divide-gray-100">
                {templates.map(temp => (
                  <div key={temp.id} className="p-4 hover:bg-gray-50 flex justify-between items-start group transition-colors cursor-pointer" onClick={() => setEditingTemplate(temp)}>
                    <div>
                      <h4 className="font-bold text-sm text-gray-800">{temp.title}</h4>
                      <p className="text-[11px] text-gray-400 mt-1">{temp.category}</p>
                    </div>
                    <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button 
                        onClick={(e) => { e.stopPropagation(); setTemplates(templates.filter(t => t.id !== temp.id)); if(editingTemplate?.id === temp.id) setEditingTemplate(null); }} 
                        className="p-1.5 text-red-500 hover:bg-red-50 rounded"
                      >
                        <SafeIcon name="Trash2" size={14} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:col-span-8">
            {editingTemplate ? (
              <form onSubmit={handleSaveTemplate} className="bg-white p-6 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-50/50 space-y-5">
                <div className="flex items-center justify-between border-b border-gray-50 pb-4 mb-2">
                  <h3 className="text-lg font-bold text-[#21438B]">
                    {editingTemplate.id ? 'Edit Template' : 'Create New Template'}
                  </h3>
                  <button type="button" onClick={() => setEditingTemplate(null)} className="text-[11px] font-bold text-gray-400 hover:text-gray-600 uppercase tracking-wider">Cancel</button>
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Template Title</label>
                  <input type="text" required value={editingTemplate.title} onChange={(e) => setEditingTemplate({...editingTemplate, title: e.target.value})} className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all text-sm" placeholder="e.g. Rejection Email" />
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Default Subject</label>
                  <input type="text" required value={editingTemplate.subject} onChange={(e) => setEditingTemplate({...editingTemplate, subject: e.target.value})} className="w-full px-4 py-2.5 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all text-sm" placeholder="Subject line" />
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">Template Body</label>
                  <textarea required rows={8} value={editingTemplate.body} onChange={(e) => setEditingTemplate({...editingTemplate, body: e.target.value})} className="w-full px-4 py-3 rounded border border-gray-200 focus:border-[#21438B] outline-none transition-all text-sm resize-none" placeholder="Body text..." />
                </div>
                <div className="pt-2">
                  <button type="submit" className="bg-[#21438B] hover:bg-[#1a3670] text-white px-8 h-11 rounded-md font-bold text-[11px] uppercase tracking-wider transition-all">
                    Save Template
                  </button>
                </div>
              </form>
            ) : (
              <div className="bg-white rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-50/50 p-12 text-center flex flex-col items-center justify-center h-full text-gray-400">
                <SafeIcon name="FileText" size={48} className="mb-4 text-gray-300" />
                <p className="font-medium text-sm">Select a template to edit or create a new one.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CandidateCommunication;